export const fmtUsd = (v) =>
  `${v < 0 ? '-' : ''}$${Math.abs(Number(v || 0)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtMonthYear = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
};

export const fmtAccountAge = (days) => {
  if (days == null) return '—';
  if (days < 1) return 'Today';
  if (days < 31) return `${days} day${days === 1 ? '' : 's'}`;
  const months = Math.floor(days / 30.44);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'}`;
  const years = Math.floor(months / 12);
  const rem = months % 12;
  return `${years} yr${years === 1 ? '' : 's'}${rem ? ` ${rem} mo` : ''}`;
};

export const timeAgo = (iso) => {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
};

export const socialUrl = (kind, value) => {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  const handle = value.replace(/^@/, '');
  if (kind === 'twitter') return `https://x.com/${handle}`;
  if (kind === 'linkedin') return `https://www.linkedin.com/in/${handle}`;
  if (kind === 'instagram') return `https://www.instagram.com/${handle}`;
  return null;
};
